import { styled } from '@mui/material';
import { Field, FormikProvider, FormikValues, useFormik } from 'formik';
import {useContext} from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import * as Yup from 'yup';
import Button from '../../../../customs/Button';
import Input from '../../../../customs/FormInput';
import apiCall from '../../../../utils/apiCall';
import { NotificationContext } from '../../../../providers/notification';
interface ModalProps{
    handleClose: () => void;
}

interface Payload {
    RouteName: string;
}

const CreateRouteContent = ({handleClose} : ModalProps) => {
    const { showNotification } = useContext(NotificationContext);
    const queryClient = useQueryClient();

    const createRoute = async (data: Payload) => {
        return await(apiCall().post('/Routes', data));
    };

    const createRouteMutation = useMutation(['create-route'], createRoute, {retry: 0});

    const createRouteHandler = async (values: FormikValues, resetForm: () => void) => {
        const payload: Payload = {
            RouteName: values?.name,
        };

        try {
            await createRouteMutation.mutateAsync(payload, {
                onSuccess: () => {
                    showNotification({
                        type: 'success',
                        message: 'Membership Route Created Successfully'
                    });
                    resetForm();
                    queryClient.refetchQueries(['get-all-routes']);
                }
            })
        } catch(error: any) {
            showNotification({
                type: 'error',
                message: error?.response?.data?.Message || error?.message,
            })
        }
    }

    const validationSchema = Yup.object().shape({
        name: Yup.string().matches(/^[A-Za-z\s!@#$%^&*()/]+$/, 'Only text is allowed').required('required'),
    })

    const formik = useFormik<FormikValues>({
        initialValues:{
            name: "",
        },
        onSubmit: (values, {resetForm}) => {
            createRouteHandler(values, resetForm);
        },
        validationSchema
    })
  return (
    <FormikProvider value={formik}>
        <form onSubmit={formik.handleSubmit}>
            <FormWrapper>
                <Field
                    name="name"
                    type="text"
                    as={Input}
                    label="Name"
                    placeholder="Name"
                />
                {/* <Field
                    name="status"
                    type="text"
                    as={Select}
                    label={"Status"}
                />  */}
            </FormWrapper>
            <ButtonWrapper>
                <ButtonContainer>
                    <StyledButton text='Cancel' onClick={handleClose}/>
                    <StyledButton 
                        type="submit" 
                        text={createRouteMutation.isLoading ? 'Submitting' : 'Submit'} 
                        disabled={createRouteMutation.isLoading} 
                    />
                </ButtonContainer>
            </ButtonWrapper>
        </form>
    </FormikProvider>
  )
}

export default CreateRouteContent

const FormWrapper = styled('div')`
    margin-inline: 3.5rem;
`

const ButtonWrapper = styled('div')`
    display: flex;
    justify-content: flex-end;
    margin-block: 2.5rem;
    padding-inline: 3.5rem;
`

const ButtonContainer = styled('div')`
    display: flex;
    gap: 2rem;
`

const StyledButton = styled(Button)`
    padding-block: 1rem;
    padding-inline: 2rem;
`

